export const GlobleConfig = {
  ImgCVOSSUrl: 'http://imgcvts.tiansole.com',
  DrJsoOSSnUrl: 'http://ts-json.tiansole.com/ocr',
};
